module.exports = __webpack_public_path__ + "static/img/black.017767b6.jpg";